"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const prop_types_1 = __importDefault(require("prop-types"));
//
// styles
//
const StyledInput_1 = require("components/general/inputs/StyledInput");
const StyledInvalidFeedback_1 = require("components/onboarding/OnboardingForm/StyledInvalidFeedback");
const MalomoText_1 = require("components/Dashboard/MalomoText");
const GenericInput = (props) => {
    return (react_1.default.createElement("div", { className: 'row g-3', key: props.id },
        react_1.default.createElement("div", { className: 'col-12 mb-3' },
            react_1.default.createElement("div", { style: {
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'baseline'
                } },
                react_1.default.createElement(MalomoText_1.MalomoText, { className: 'form-label', htmlFor: props.id, label: true, style: { fontWeight: props.boldLabel ? 'bold' : '' } }, props.label),
                props.rightLabel),
            react_1.default.createElement(StyledInput_1.StyledInput, { className: props.error ? 'form-control is-invalid' : 'form-control', "data-id": props['data-id'], disabled: props.disabled, id: props.id, onBlur: props.onBlur, onChange: props.onInputChange, placeholder: props.placeholder ? props.placeholder : '', type: 'text', value: props.value }),
            props.error ? (react_1.default.createElement(StyledInvalidFeedback_1.StyledInvalidFeedback, { className: 'invalid-feedback' }, props.error)) : null)));
};
GenericInput.propTypes = {
    boldLabel: prop_types_1.default.bool,
    ['data-id']: prop_types_1.default.string,
    disabled: prop_types_1.default.bool,
    error: prop_types_1.default.string,
    id: prop_types_1.default.string,
    label: prop_types_1.default.string,
    onBlur: prop_types_1.default.func,
    onInputChange: prop_types_1.default.func,
    placeholder: prop_types_1.default.string,
    rightLabel: prop_types_1.default.element,
    spacing: prop_types_1.default.string,
    value: prop_types_1.default.string
};
exports.default = GenericInput;
